// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-orange{\n    color: #fff !important;\n    background: #f17c2b;\n    border-color: #f17c2b\n}\n.btn-grey{\n    background-color: #6c757d;\n    color: #ffffff;\n    border: none;\n}\n\n.toolboxControl {\n    max-height: 0%;\n    transition: 0.5s;\n    overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
